import React from "react";

import "./index.css";

const readingPlan2023 = 
  "/pdf/WACReadingPlan2023.pdf";

function ReadingPlanForTheYear() {
  return (
    <div className="DownloadReadingPlan__component">
      <a href={readingPlan2023} target="_blank" rel="noopener noreferrer">
        2023 Reading Plan PDF
      </a>
      <br />
    </div>
  );
}

export default ReadingPlanForTheYear;
